// src/pages/PaineisLED.js
import React from 'react';
import { Helmet } from 'react-helmet'; // <<< ADICIONADO: Importação do Helmet
import './PaineisLED.css'; // Criaremos este arquivo a seguir
import ContactForm from '../components/ContactForm'; // Importando nosso formulário
import { FaStore, FaBuilding, FaVideo } from 'react-icons/fa'; // Ícones para os segmentos

// Importando as logos (reutilizando da HomeIntelbras)
import logoPts from '../assets/intelbras/logo-pts.png';
import logoIntelbras from '../assets/intelbras/logo-intelbras.png';

// --- Ação Necessária ---
// Certifique-se de que estas imagens existam na pasta 'src/assets/led/'
// (São as 5 imagens .jpg que você subiu da Intelbras)
import imgHero from '../assets/led/banner_painel_led.jpg';
import imgVibrantes from '../assets/led/imagens-vibrantes-independentes-da-luminosidade-led-7025-fixo-indoor.jpg';
import imgSemBordas from '../assets/led/nada-de-bordas-e-emendas-led-7025-fixo-indoor.jpg';
import imgTecnologia from '../assets/led/tecnologia-inovadora-para-a-sua-comunicacao-led-7025-fixo-indoor.jpg';
import imgAplicacoes from '../assets/led/aplicacoes-diversas-led-7025-fixo-indoor.jpg';
import painelled1 from '../assets/led/painel-led-1.jpg';
import painelled2 from '../assets/led/painel-led-2.jpg';



const PaineisLED = () => {

    // Função para scroll suave até o formulário
    const handleScrollToForm = (e) => {
        e.preventDefault();
        document.getElementById('form-led').scrollIntoView({ behavior: 'smooth' });
    };

    // --- ADICIONADO: Bloco de Dados Estruturados (JSON-LD) para SEO ---
    const schemaData = {
      "@context": "https://schema.org",
      "@type": "ProfessionalService",
      "name": "Primo Trade Solutions (PTS)",
      "image": "https://www.primotradesolutions.com.br/logo.png", // Use a URL absoluta do seu logo
      "@id": "https://www.primotradesolutions.com.br/", // URL da sua homepage
      "telephone": "+55-11-97721-1739", // Telefone principal de contato
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "Rua Dr. Pedro Ferreira, 333 - Sala 1206 Box 250",
        "addressLocality": "Itajaí",
        "addressRegion": "SC",
        "postalCode": "88301-030",
        "addressCountry": "BR"
      },
      "description": "Especialistas em instalação de painéis de LED, segurança e automação Intelbras.",
      "serviceType": "Instalação de Painel de LED",
      "areaServed": {
        "@type": "Country",
        "name": "Brasil"
      },
      "makesOffer": {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Projeto e Instalação de Painel de LED Intelbras",
          "url": "https://www.primotradesolutions.com.br/paineis-de-led",
          "description": "Soluções completas para comunicação visual digital, incluindo consultoria, projeto, instalação qualificada e gestão de conteúdo para painéis de LED no varejo, empresas e eventos.",
          "provider": {"@type": "ProfessionalService", "name": "Primo Trade Solutions (PTS)"}
        }
      }
    };
    // --- FIM DO BLOCO ADICIONADO ---


    return (
        <div className="paineis-led-page">
            
            {/* --- ADICIONADO: Bloco <Helmet> para SEO --- */}
            <Helmet>
                <title>Instalação de Painel de LED Intelbras | Projetos | PTS</title>
                <meta name="description" content="Potencialize sua comunicação com Painéis de LED profissionais Intelbras. A PTS cuida do projeto, instalação e gestão. Ideal para varejo, empresas e eventos." />
                <meta name="keywords" content="painel de led, painel de led intelbras, instalação painel de led, projeto painel de led, vitrine digital, comunicação visual digital, pts, primo trade solutions" />
                <link rel="canonical" href="https://www.primotradesolutions.com.br/paineis-de-led" />
                
                {/* Open Graph (para Facebook, LinkedIn, etc.) */}
                <meta property="og:title" content="Instalação de Painel de LED Intelbras | Projetos | PTS" />
                <meta property="og:description" content="Transforme sua vitrine ou recepção. A PTS é especialista em projetos e instalação de Painéis de LED Intelbras. Peça uma cotação." />
                <meta property="og:image" content="https://www.primotradesolutions.com.br/logo.png" /> 
                <meta property="og:url" content="https://www.primotradesolutions.com.br/paineis-de-led" />
                <meta property="og:type" content="website" />

                {/* Twitter Cards */}
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="Instalação de Painel de LED Intelbras | Projetos | PTS" />
                <meta name="twitter:description" content="Transforme sua vitrine ou recepção. A PTS é especialista em projetos e instalação de Painéis de LED Intelbras. Peça uma cotação." />
                <meta name="twitter:image" content="https://www.primotradesolutions.com.br/logo.png" /> 
                
                {/* Script de Dados Estruturados (JSON-LD) */}
                <script type="application/ld+json">
                    {JSON.stringify(schemaData)}
                </script>
            </Helmet>
            {/* --- FIM DO BLOCO ADICIONADO --- */}


            {/* --- Bloco 1: O Impacto (Atração) --- */}
            <section 
                className="led-hero" 
                style={{ backgroundImage: `url(${imgHero})` }}
            >
                
            </section>

            {/* --- Bloco 2: A Oportunidade (Identificação) --- */}
            <section className="led-segmentos container">
                <h2>Banners desbotados e TVs pequenas não geram mais resultados.</h2>
                <p className="subtitulo">A sua comunicação precisa estar no mesmo nível da sua marca. Seja qual for o seu negócio, existe uma solução de LED para você.</p>
                <a href="#form-led" className="cta-button" onClick={handleScrollToForm}>
                    Quero um Projeto de Impacto
                </a>
                
                <div className="segmentos-container">
                    <div className="segmento-card">
                        <FaStore size={40} className="segmento-icon" />
                        <h3>Varejo & Lojas</h3>
                        <p>Transforme sua vitrine em um outdoor dinâmico. Destaque promoções, atraia clientes na calçada e modernize seu ponto de venda.</p>
                        <span><strong>Ideal para:</strong> Lojas, Restaurantes, Mercados, Shoppings.</span>
                    </div>
                    <div className="segmento-card">
                        <FaBuilding size={40} className="segmento-icon" />
                        <h3>Corporativo & Empresas</h3>
                        <p>Impressione visitantes e investidores com um lobby tecnológico. Apresente resultados e comunicados internos em grande formato.</p>
                        <span><strong>Ideal para:</strong> Escritórios, Bancos, Indústrias, Hotéis.</span>
                    </div>
                    <div className="segmento-card">
                        <FaVideo size={40} className="segmento-icon" />
                        <h3>Eventos & Alto Fluxo</h3>
                        <p>Garanta que sua mensagem seja vista por todos, com brilho e clareza, mesmo em ambientes claros ou a longas distâncias.</p>
                        <span><strong>Ideal para:</strong> Igrejas, Casas de Show, Centros de Convenção.</span>
                    </div>
                </div>
            </section>

            {/* --- Bloco 3: A Galeria (Desejo) --- */}
            <section className="led-galeria">
                <div className="container">
                    <h2>Veja o que é possível: sem bordas, sem emendas.</h2>
                    <p className="subtitulo">Com os gabinetes modulares, criamos formatos e tamanhos personalizados para o seu projeto, seja ele uma coluna, um painel curvo ou uma parede inteira.</p>
                    <a href="#form-led" className="cta-button" onClick={handleScrollToForm}>
                        Quero um Projeto de Impacto
                    </a>
                    <div className="galeria-grid">
                        <img src={imgVibrantes} alt="Painel de LED com imagens vibrantes em cafeteria ou restaurante" />
                        <img src={imgSemBordas} alt="Painel de LED sem bordas ou emendas em corredor de loja" />
                        <img src={imgTecnologia} alt="Tecnologia inovadora em painel de LED em corredor de restaurante ou aeroporto" />
                        <img src={imgAplicacoes} alt="Aplicações diversas de painéis de LED em feira de evento no palco" />
                        <img src={painelled1} alt="Aplicações diversas de painéis de LED em corredor de empresa ou loja" />
                        <img src={painelled2} alt="Aplicações diversas de painéis de LED em lojas de artigos do vestuário" />
                    </div>
                </div>
            </section>

            {/* --- Bloco 4: A Solução PTS (Confiança) --- */}
            <section className="led-solucao-pts container">
                <div className="confianca-logos">
                    <img src={logoPts} alt="Logo PTS Primo Trade Solutions" />
                    <span>+</span>
                    <img src={logoIntelbras} alt="Logo Intelbras" />
                </div>
                <h2>Mais que um Painel. Uma Solução Completa.</h2>
                <p className="subtitulo">A Intelbras fornece a tecnologia de ponta. A <strong>PTS</strong> entrega o <strong>projeto, a instalação e o resultado.</strong></p>
                <a href="#form-led" className="cta-button" onClick={handleScrollToForm}>
                    Quero um Projeto de Impacto
                </a>
                
                <div className="diferenciais-container">
                    <div className="diferencial-card">
                        <h3>1. Consultoria & Projeto</h3>
                        <p>Analisamos seu ambiente, a distância de visualização e o fluxo de pessoas para definir o <i>pixel pitch</i> ideal (ex: 2.5mm ou 3.0mm) e o tamanho exato para o seu orçamento.</p>
                    </div>
                    <div className="diferencial-card">
                        <h3>2. Instalação Qualificada</h3>
                        <p>Nossa equipe é certificada pela Intelbras. Garantimos uma instalação limpa, segura e dentro do prazo, configurando 100% do equipamento.</p>
                    </div>
                    <div className="diferencial-card">
                        <h3>3. Durabilidade 24/7</h3>
                        <p>Projetos para operação contínua. São mais de <strong>100.000 horas de vida útil</strong> para sua mensagem nunca parar.</p>
                    </div>
                    <div className="diferencial-card">
                        <h3>4. Gestão Simplificada</h3>
                        <p>Entregamos a solução com um software de gerenciamento de conteúdo fácil de usar e treinamos sua equipe para operar.</p>
                    </div>
                </div>
            </section>


            {/* --- Bloco 5 & 6: A Chamada e Formulário (Escassez + Ação) --- */}
            <section id="form-led" className="led-captura">
                <div className="container">
                    <h2>Vamos dar vida ao seu projeto?</h2>
                    <p className="oferta">
                        O primeiro passo é o mais importante. Entre em contato agora mesmo e solicite uma<br/>
                        <strong>Cotação do seu projeto de Painel de LED.</strong>
                    </p>
                    <a href="#form-led" className="cta-button" onClick={handleScrollToForm}>
                        Quero um Projeto de Impacto
                    </a>
                    
                    {/* O </div> de fechamento FOI REMOVIDO DAQUI */}

                </div>
            </section>
            {/* --- Bloco 5: Formulário de Contato ---
              A seção 'led-captura' e todo o texto de marketing foram removidos.
              Esta 'section' agora serve apenas como âncora (id="form-led") para o botão do topo.
              O componente ContactForm renderizará a si mesmo, com seu próprio estilo (fundo branco, etc.).
            */}
            <section id="form-led">
                <ContactForm />
            </section>

        </div>
    );
};

export default PaineisLED;